module.exports = __webpack_public_path__ + "static/media/feifengshan_web.2a502b00.webp";